module.exports = {"test":{"cpOne":"https://cp-one-alpha.corp.amazon.com/","bingo":"https://bingo.aws.a2z.com/dashboard"},"alpha":{"cpOne":"https://cp-one-alpha.corp.amazon.com/","bingo":"https://bingo.aws.a2z.com/dashboard"},"beta":{"cpOne":"https://cp-one-beta.corp.amazon.com/","bingo":"https://bingo.aws.a2z.com/dashboard"},"gamma":{"cpOne":"https://cp-one-gamma.corp.amazon.com/","bingo":"https://bingo.aws.a2z.com/dashboard"},"prod":{"cpOne":"https://cp-one.corp.amazon.com/","bingo":"https://bingo.aws.a2z.com/dashboard"}}


//////////////////
// WEBPACK FOOTER
// ./src/data/configSet.json
// module id = 91
// module chunks = 0